export const PHONE_BREAKPOINT=768
export const SCALE_BREAKPOINT=1344
